import * as tslib_1 from "tslib";
import React from 'react';
import SystemNotification from '../../SystemNotification';
import ErrorBoundary from '../../ErrorBoundary';
var durations = {
    XS: 2000,
    S: 2500,
    M: 3000,
    L: 4000,
    XL: 5000,
};
var Notification = /** @class */ (function (_super) {
    tslib_1.__extends(Notification, _super);
    function Notification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pause = function () {
            if (!_this.timerExpectedEnd) {
                return;
            }
            _this.pauseRemainingTime = Math.max(_this.timerExpectedEnd - new Date().getTime(), 0);
            if (_this.pauseRemainingTime) {
                _this.clearDismissTimeout();
            }
        };
        _this.unpause = function () {
            if (!_this.pauseRemainingTime) {
                return;
            }
            _this.setDismissTimeout(_this.props.id, _this.pauseRemainingTime);
        };
        // We do not use this.props.id so the remove works even if a different
        // message is showing now. Weird stuff like that happens with timeouts
        _this.onClose = function (id) {
            var removeNotification = _this.props.removeNotification;
            removeNotification(id);
        };
        return _this;
    }
    Notification.prototype.componentDidMount = function () {
        this.setDismissTimeout(this.props.id);
    };
    Notification.prototype.componentDidUpdate = function () {
        this.setDismissTimeout(this.props.id);
    };
    Notification.prototype.componentWillUnmount = function () {
        this.clearDismissTimeout();
    };
    Notification.prototype.shouldComponentUpdate = function (prevProps) {
        // this is because there is some weird tearing while adding/removing notifs
        return this.props.id !== prevProps.id;
    };
    Notification.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, removeNotification = _a.removeNotification, notifProps = tslib_1.__rest(_a, ["id", "removeNotification"]);
        return (React.createElement(ErrorBoundary, null,
            React.createElement(SystemNotification, tslib_1.__assign({}, notifProps, { onClose: function () { return _this.onClose(id); }, onMouseEnter: this.pause, onMouseLeave: this.unpause }))));
    };
    Notification.prototype.clearDismissTimeout = function () {
        if (!this.dismissTimeout) {
            return;
        }
        clearTimeout(this.dismissTimeout);
        this.dismissTimeout = null;
        this.timerExpectedEnd = 0;
    };
    Notification.prototype.setDismissTimeout = function (id, duration) {
        var effectiveDuration = duration === undefined ? this.getDuration() : duration;
        this.clearDismissTimeout();
        this.dismissTimeout = setTimeout(this.onClose.bind(null, id), effectiveDuration);
        this.timerExpectedEnd = new Date().getTime() + effectiveDuration;
        this.pauseRemainingTime = 0;
    };
    Notification.prototype.getDuration = function () {
        var _a = this.props, _b = _a.multiLine, multiLine = _b === void 0 ? false : _b, _c = _a.actions, actions = _c === void 0 ? [] : _c;
        if (!multiLine) {
            if (!actions.length) {
                return durations.XS;
            }
            if (actions.length === 1) {
                return durations.S;
            }
            return durations.M;
        }
        // there is a divergence between zeplin and axure between L and XL
        // L was axed from Zeplin, but the XL is actually more like L in axure
        // in the end based on a fair coin flip I chose to use XL
        return durations.XL;
    };
    return Notification;
}(React.Component));
export { Notification };
export default Notification;
//# sourceMappingURL=Notification.js.map